import { ModalContent, ModalFooter } from '@components/secondary-modal';
import { ResponseStatuses } from '@src/utils/enums';

const statusModal = ({ msg, status, onSave, saveText = 'OK', cancelText, hasCloseButton = true }) => (
  <ModalContent
    hasCloseButton={hasCloseButton}
    title={status === ResponseStatuses.Success ? 'SUCCESS!' : status === ResponseStatuses.Failed ? 'ERROR!' : status}
  >
    <section className='modal-body' style={{ maxHeight: '600px', overflowY: 'auto' }}>
      <div>{msg}</div>
    </section>
    <ModalFooter saveText={saveText} showCancelButton={cancelText} onSave={onSave} cancelText={cancelText} />
  </ModalContent>
);
export default statusModal;
